import { render, staticRenderFns } from "./EventForm2.vue?vue&type=template&id=460337ed&scoped=true"
import script from "./EventForm2.vue?vue&type=script&lang=js"
export * from "./EventForm2.vue?vue&type=script&lang=js"
import style0 from "./EventForm2.vue?vue&type=style&index=0&id=460337ed&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "460337ed",
  null
  
)

export default component.exports